import { type FC } from 'react';

import { Text } from '@livechat/design-system-react-components';

import { shinyTextStyle } from './styles';

export const CopilotReasoningStatus: FC = () => {
  return <Text className={shinyTextStyle}>Thinking...</Text>;
};
